import React from "react"

export default props => {
    return (
        <div>Dashboard</div>
    )
}